/* © 2017 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, January 01, 2017
 * For information or permission request, email info@aetonixsystems.com
 */

import React from "react";

import OutputForm from "./OutputForm";
import OutputText from "./OutputText";
import OutputRow from "./OutputRow";
import OutputList from "./OutputList";
import OutputNotification from "./OutputNotification";
import OutputCollapsable from "./OutputCollapsable";
import OutputFiles from "./OutputFiles";
import OutputFile from "./OutputFile";
import OutputDays from "./OutputDays";
import OutputWeight from "./OutputWeight";
import OutputStatus from "./OutputStatus";
import OutputMarkdown from "./OutputMarkdown";
import OutputReading from "./OutputReading";
import OutputExternalForm from "./OutputExternalForm";
import OutputRange from "./OutputRange";
import OutputSignature from "./OutputSignature";
import OutputCustomOptions from "./OutputCustomOptions";
import OutputCopyableText from "./OutputCopyableText";

var global = require("global");

export default function Output(props) {
	var schema = props.schema || {};
	var data = props.data || props.defaultValue;
	var type = schema.type;

	var extraProps = {};

	var displayType = schema.displayType;
	var Component = OutputText;

	var isATALauncher = global.cordova;

	if(displayType === "hidden")
		return null;
	else if(displayType === "form" || (!displayType && type === "object"))
		Component = OutputForm;
	else if(displayType === "collapsable")
		Component = OutputCollapsable;
	else if(displayType === "list" || (!displayType && type === "array"))
		Component = OutputList;
	else if(displayType === "days")
		Component = OutputDays;
	else if(displayType === "row")
		Component = OutputRow;
	else if(displayType === "notification")
		Component = OutputNotification;
	else if(displayType === "files")
		Component = OutputFiles;
	else if(displayType === "file")
		Component = OutputFile;
	else if(displayType === "weight")
		Component = OutputWeight;
	else if(displayType === "status")
		Component = OutputStatus;
	else if (displayType === "markdown")
		Component = OutputMarkdown;
	else if(displayType === "reading")
		Component = OutputReading;
	else if(displayType === "title")
		extraProps.title = true;
	else if(displayType === "scale")
		Component = OutputRange;
	else if(displayType === "externalform")
		Component = OutputExternalForm;
	else if(displayType === "signature")
		Component = OutputSignature;
	else if(displayType === "copyable" && !isATALauncher)
		Component = OutputCopyableText;
	else if(displayType === "nested") {
		var displayProperty = schema.displayProperty;
		var order = schema.properties[displayProperty].order;
		data = data ? data[displayProperty] : null;
		if(order === undefined)
			schema.properties[displayProperty].order = schema.order;
		schema = schema.properties[displayProperty];
		Component = Output;
	}
	else if (displayType === "customOptions"){
		Component = OutputCustomOptions;
	}

	return (
		<Component schema={schema} data={data} style={props.style} contrast={props.contrast} large={props.large} noPdfFullScreen={props.noPdfFullScreen} {...extraProps} />
	);

}